import {
  Box,
  Button,
  SearchField,
  Tag,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { DateNavigator } from 'modules/core/components/DateNavigator'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ScheduleRecordValuesType } from '../Body/ScheduleItem/types'
import ProjectFilter from './ProjectFilter'

interface IScheduleActionsProps {
  range: [Date, Date]
  setRange: (range: [Date, Date]) => void
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
  showBetaTag: boolean
  onChangeFilter: (filterValue: Record<string, number[]>) => void
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
  isMyProjectsView?: boolean
}

const ScheduleActions = ({
  range,
  setRange,
  openSidepanel,
  showBetaTag,
  onChangeFilter,
  onSearch,
  search,
  isMyProjectsView = false,
}: IScheduleActionsProps) => {
  const [toggle, setToggle] = useToggle(false)
  const onClickToday = () => {
    setRange([moment().startOf('month').toDate(), moment().endOf('month').toDate()])
  }

  const handleOnClickAssignHoursButton = () => {
    track(trackingEvents.projectManagement.schedule.clickAssignHoursButton, {})
    openSidepanel()
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" paddingX="s24" paddingY="s16">
      <Box flexDirection="row">
        {!isMyProjectsView && <ProjectFilter onChangeFilter={onChangeFilter} />}
      </Box>
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Button type="secondary" onClick={onClickToday}>
          {i18n.t('common.today')}
        </Button>
        <DateNavigator
          regularPeriods={['month']}
          startDate={range[0] ?? new Date()}
          endDate={range[1] ?? new Date()}
          onDateRangeChange={(...newRange) => setRange(newRange)}
        />
        {showBetaTag && !isMyProjectsView && (
          <Tooltip.Alt
            open={toggle}
            toggle={setToggle}
            label={i18n.t('project_management.schedule.banner.tag.tooltip')}
            attachment="bottom center"
          >
            <Tag leftItem="circle" showCircle type="viridian" size="small">
              <Text weight="medium" size="200">
                {i18n.t('project_management.schedule.banner.tag.title')}
              </Text>
            </Tag>
          </Tooltip.Alt>
        )}
      </Box>

      <Box flexDirection="row" justifyContent="flexStart" paddingX="s24">
        {!isMyProjectsView && (
          <>
            <Box paddingX="s12">
              <SearchField
                collapsable
                search={search}
                onSearch={onSearch}
                placeholder={i18n.t('common.search')}
              />
            </Box>
            <Button iconName="add" type="primary" onClick={handleOnClickAssignHoursButton}>
              {i18n.t('project_management.schedule.buttons.assign_hours')}
            </Button>
          </>
        )}
      </Box>
    </Box>
  )
}

export default ScheduleActions
